/* oos-sort.js – produsele in stoc primele, cele complet epuizate la final. */
(function () {
  'use strict';

  var html = document.documentElement;
  function reveal() { html.classList.remove('oos-loading', 'oos-p1'); }
  function isSoldOut(c) {
    return c.classList.contains('product-block--soldout') || !!c.querySelector('.product-block__image--soldout');
  }

  function parse(txt) {
    var doc = new DOMParser().parseFromString(txt, 'text/html');
    var m = doc.getElementById('oos-meta');
    return {
      hasMeta: !!m,
      items: m ? parseInt(m.dataset.items, 10) : 0,
      size: m ? parseInt(m.dataset.pageSize, 10) : 0,
      cards: Array.prototype.slice.call(doc.querySelectorAll('.product-block'))
    };
  }
  async function get(url) {
    var r = await fetch(url, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return parse(await r.text());
  }

  async function run() {
    var o = window.__oos;
    var meta = document.getElementById('oos-meta');
    if (!o || !meta) return reveal();
    var section = meta.closest('.shopify-section');
    var list = section && section.querySelector('.product-list');
    if (!list) return reveal();

    var sectionId = section.id.replace('shopify-section-', '');
    var S = parseInt(meta.dataset.pageSize, 10);
    var N = parseInt(meta.dataset.items, 10);
    var page = parseInt(meta.dataset.page, 10) || 1;

    var inRes = parse(await o.first);
    if (!inRes.hasMeta) throw new Error('Sectiunea oos-grid lipseste');
    if (inRes.size !== S) throw new Error('oos-grid: ' + inRes.size + ' produse/pagina, colectia: ' + S);
    if (inRes.cards.some(isSoldOut)) throw new Error('Filtrul nu se aplica pe aceasta colectie');
    var nIn = inRes.items;
    if (nIn >= N) return reveal();

    var start = S * (page - 1);
    var cards = start < nIn ? inRes.cards : [];
    var need = Math.min(S, N - start) - cards.length;

    if (need > 0) {
      var offset = Math.max(0, start - nIn);
      var pool = [], next = 1, last = Infinity;
      while (pool.length < offset + need && next <= last) {
        var want = Math.max(1, Math.ceil((offset + need - pool.length) / S));
        var batch = [];
        for (var i = 0; i < want && next <= last; i++) batch.push(get(o.url(0, next++)));
        var results = await Promise.all(batch);
        for (var j = 0; j < results.length; j++) {
          last = Math.ceil(results[j].items / S);
          pool = pool.concat(results[j].cards.filter(isSoldOut));
        }
      }
      cards = cards.concat(pool.slice(offset, offset + need));
    }

    var seen = {};
    cards = cards.filter(function (c) {
      var id = c.getAttribute('data-product-id');
      if (seen[id]) return false;
      seen[id] = true;
      return true;
    });

    section.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: sectionId } }));
    list.replaceChildren.apply(list, cards.map(function (c) { return document.importNode(c, true); }));
    section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
    list.querySelectorAll('.cc-animate-init').forEach(function (el) {
      el.classList.add('-in', 'cc-animate-complete');
    });
    reveal();
  }

  function start() {
    run().catch(function (e) { console.warn('[oos-sort]', e.message); reveal(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();